import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import FlagIcon from '@wwt/shared/assets/icons/outline/ukraine-flag.svg'

import { Button } from '@/shared/ui/Button.tsx'

import './support-button.css'

interface SupportButtonProps {
	size?: 'sm' | 'lg'
}

export const SupportButton = ({ size }: SupportButtonProps) => {
	const { t } = useTranslation('header')
	return (
		<Button
			asChild
			variant="outline"
			className="support-button"
			size={size || 'default'}
		>
			<Link
				to="https://ko-fi.com/winwintravel"
				target="_blank"
			>
				<div className="flex items-center justify-between gap-4 [&_svg]:h-3 [&_svg]:w-4">
					<FlagIcon />
					<span>{t('support')}</span>
				</div>
			</Link>
		</Button>
	)
}
